if (!customElements.get('sparky-shuffle')) {
  class SparkyShuffle extends HTMLElement {
    constructor() {
      super();
    }

    init() {
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale   
    }
    
    connectedCallback() {      
      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
      
      this.addEventListener('click', e => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
          productHandle,
        } = clickedElement.dataset;
        
        switch (action) {
          case 'product-select':
            history.replaceState('', '', `${this.locale ? `/${this.locale}` : `` }/products/${productHandle}`);
            document.querySelectorAll('[data-section]').forEach((sectionWrapper) => {
              sectionWrapper.querySelectorAll('product-form').forEach(f => f.replaceWith(Object.assign(document.createElement('div'), {innerHTML: f.innerHTML, className: f.className})));
              const sectionId = sectionWrapper.dataset.section;
              const loader = document.querySelector(`template[data-loader="${sectionId}"]`)?.cloneNode(true);
              const sectionInnerHTML = sectionWrapper.innerHTML;
              
              sectionWrapper.innerHTML = `
                <intersection-loader 
                  data-url="${this.locale ? `/${this.locale}` : `` }/products/${productHandle}"
                  data-section-id="${sectionId}"
                  class="${sectionWrapper.classList}"
                  data-load-immediately="true"
                >${loader ? loader.innerHTML : sectionInnerHTML}</intersection-loader>
              `;
            });
            
             // keeps the price up to date with actual selection across section loads
            // const observer = new MutationObserver(observerCallback.bind(this));
            // observer.observe(this, { childList: true, subtree: true });
            
            // function observerCallback(mutationList) {
            //   for (const mutation of mutationList) {
            //     if (mutation.type === 'childList') {
            //       if (mutation.target.dataset.section === "product-panel-header") {
            //         poll(() => {
            //             return this.querySelector('product-form:not(:has(intersection-loader))');
            //           }, 10000, 150)
            //             .then(() => {
            //               this.querySelector('product-form').updatePriceDisplay()
            //             });
            //       }
            //     }
            //   }
            // }            
          break;
          default:
          break;
        }
      });
        const gallery = this.querySelector('[data-mobile-gallery]');      
        const videos = gallery.querySelectorAll('video');
        if (videos.length === 0) return;
      
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.play().catch(error => {});
            } else {
              video.pause();
            }
          });
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 1.0
        });
      
        videos.forEach(video => {
          observer.observe(video);
        });

    }
  }
  
  customElements.define('sparky-shuffle', SparkyShuffle);
}